import './App.css';
import Main from './module/main';

function App() {
  return <Main />;
}

export default App;
